import { ColTypeDef, ValueFormatterParams, ValueGetterParams } from 'ag-grid-community';
import { LabelItem } from 'components/shared/compact-selector/types';
import { Custodian } from 'models/custodian';
import { useMemo } from 'react';
import { CellRendererAsEditorWrapper } from 'routes/secondary-market-batch/grid/components/cell-render-as-editor-wrapper';
import { CustodianCellEditor } from 'routes/secondary-market-batch/grid/components/custodian-cell-editor';
import { SecondaryCellEditorProps, SecondaryCellRendererProps } from 'routes/secondary-market-batch/grid/types';
import { equalsById } from 'routes/secondary-market-batch/grid/utils/equals-by-id';
import { RowData } from 'state/workspaces/secondary-market/batch/model';
export const formatCustodianLabel = (custodian: LabelItem | undefined | null): string => {
  if (!custodian) {
    return '';
  }
  const parts = [custodian.id];
  if (custodian.eliotCode) {
    parts.push(custodian.eliotCode);
  }
  return `${custodian.label} (${parts.join(' - ')})`;
};

export function useCustodianColumnType(): ColTypeDef<RowData, RowData[keyof RowData]> {
  return useMemo(
    () => ({
      filter: 'agTextColumnFilter',
      filterParams: {
        filterOptions: ['contains', 'notContains'],
      },
      useValueFormatterForExport: true,
      valueFormatter: ({ value }: ValueFormatterParams<RowData>) => {
        const custodian = value as Custodian | undefined;
        return custodian?.eliotCode!;
      },
      filterValueGetter: ({ getValue, colDef }: ValueGetterParams<RowData>) => {
        const custodian = colDef.field ? getValue(colDef.field) : (undefined as Custodian | undefined);
        return `${custodian?.label} (${custodian?.id} - ${custodian?.eliotCode})`;
      },
      equals: equalsById,
      cellEditor: (p: SecondaryCellEditorProps<Custodian>) => <CustodianCellEditor {...p} type="editor" />,
      cellRenderer: (p: SecondaryCellRendererProps<Custodian>) => (
        <CellRendererAsEditorWrapper {...p} render={CustodianCellEditor} />
      ),
    }),
    [],
  );
}
